interface BuildFmaReportsHeadersInput {
  document: string
  stoneAccountId?: string
  paymentProfileIds?: string[]
}

const MAX_PAYMENT_PROFILE_IDS = 25

export function buildFmaReportsHeaders({
  document,
  stoneAccountId,
  paymentProfileIds
}: BuildFmaReportsHeadersInput): Record<string, string> {
  const headers: Record<string, string> = {
    'x-document': document,
    'x-institution': 'stone'
  }

  if (stoneAccountId) {
    headers['x-stone-account-id'] = stoneAccountId
  }

  if (paymentProfileIds && paymentProfileIds.length > 0) {
    headers['x-payment-profile-id'] = paymentProfileIds.slice(0, MAX_PAYMENT_PROFILE_IDS).join(',')
  }

  return headers
}
